// src/components/Gallery/Gallery.js
import React from 'react';
import './Gallery.css';

function Gallery({ products = [] }) {
    const images = products
        .filter((product) => product.category === 'tshirt' && product.name?.toLowerCase().includes('наличники'))
        .flatMap((product) => (product.images || []).slice(0, 2).map((src, imageIndex) => ({
            src,
            colorName: product.color_name || '',
            colorCode: product.color_code || '#777',
            view: imageIndex === 0 ? 'Вид спереди' : 'Вид сзади',
            alt: `${product.name}, ${product.color_name || 'цвет не указан'}, ${imageIndex === 0 ? 'вид спереди' : 'вид сзади'}`,
        })));

    if (images.length === 0) return null;

    return (
        <section id="fit" className="gallery" aria-labelledby="gallery-title">
            <div className="container">
                <div className="gallery-header">
                    <div>
                        <p className="section-kicker">Как сидит</p>
                        <h2 id="gallery-title">Посмотрите<br />со всех сторон.</h2>
                    </div>
                    <p>
                        Парни и девушки, фронт и спина. Переключайте ракурсы в карточке
                        товара перед выбором размера.
                    </p>
                </div>
                <div className="gallery-grid">
                    {images.map((img, index) => (
                        <figure key={index} className="gallery-item">
                            <img src={img.src} alt={img.alt} loading="lazy" decoding="async" width={700} height={700} />
                            <figcaption>
                                <span><i style={{ backgroundColor: img.colorCode }} aria-hidden="true" />{img.colorName}</span>
                                <span>{img.view}</span>
                            </figcaption>
                        </figure>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Gallery;
